<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12  v-if="type != 'box' && type != 'bag' && type != 'pcs' && type != 'pkt'">
          <v-text-field
           
            v-model="weight"
            v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.1)"
            type="number"
            ref="weight"
            label="weight(kg)"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="quantity"
            v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
            ref="qty"
            type="number"
            label="Qty"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="price"
            v-on:change="price = Math.max(Math.min(price, 9999999), 0.01)"
            ref="price"
            type="number"
            label="Price"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-autocomplete
            v-model="grade"
            :items="gradeList"
            item-text="name"
            item-value="name"
            label="Grade"
            ref="grade"
            chips
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-autocomplete
            v-model="location"
            :items="locationList"
            item-text="name"
            item-value="name"
            label="Location"
            ref="location"
            chips
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 sm12 md12 v-if="type=='basket'">
          <v-autocomplete
            v-model="basket"
            :items="basketList"
            item-text="text"
            item-value="value"
            label="Basket"
            ref="basket"
            chips
          ></v-autocomplete>
        </v-flex>
        <v-btn color="primary" @click="update_item() ">Update</v-btn>
      </v-layout>
    </v-container>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import { type } from 'os';

export default {
  data: () => ({
    baseUrl: baseUrl,
    basketList:[  { text: "basket", value: true },
        { text: "no basket", value: false }],
    locationList: [],
    gradeList: [],
    item_id: "",
    grade: "",
    location: "",
    weight: "",
    price: "",
    quantity: "",
    type: "",
    basket:"",
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response: "",
    response_detail: "",
    vege_adding_loading_value: "",
    customer_id:""
  }),

  created() {
    this.getGrade();
    this.getLocation();
  },

  methods: {
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    fetch_item(id,customer_id) {
      console.log("customer_id");

      console.log(customer_id);
      this.customer_id=customer_id;
      const params = new URLSearchParams();
      params.append("get_item_to_edit", "get_item_to_edit");
      params.append("id", id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.item_id = response.data.id;
            console.log(this.item_id);
            this.grade = response.data.grade;
            this.location = response.data.location;
            this.weight = response.data.weight;
            this.quantity = response.data.quantity;
            this.price = response.data.price;
            this.type = response.data.type;
            this.basket = (parseFloat(response.data.basket_item_quantity)>0?true:false);

            console.log(this.type);
          } else if (response.data.error == true) {
            this.item_id = "";
            this.grade = "";
            this.location = "";
            this.weight = "";
            this.quantity = "";
            this.price = "";
            this.type = "";
            this.basket = "";
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    update_item() {
      if(this.weight && this.quantity){
          if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }
      const params = new URLSearchParams();
      params.append("update_edit_item", "update_edit_item");
      params.append("id", this.item_id);
      params.append("grade", this.grade);
      params.append("location", this.location);
      params.append("weight", this.weight);
      params.append("quantity", this.quantity);
      params.append("price", this.price);
      params.append("type", this.type);
      params.append("basket", (this.basket==true?'1':'0'));
      params.append("customer_id", this.customer_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.$emit("update", "someValue");
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.$emit("update", "someValue");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });}else{

           this.snackbar_response = true;
            this.response_detail = "fill in all the detail";
        }
    }
  }
};
</script>

